import type { RouteRecordRaw } from 'vue-router'
import userSettingsRoutes from '@/routes/BackOffice/userSettings'
import backOfficeRoutes from '@/routes/BackOffice/backOffice'

export default <RouteRecordRaw[]>[...backOfficeRoutes, ...userSettingsRoutes]
